import React from 'react'
import * as S from './styles'


const FooterAddress: React.FC = () => (
    <S.ContainerFooter>
       <S.LabelFooter>
        Grupo de Moda SOMA S.A. <p>  Av. Coronel Phidias Tavora 360, Blc 1 armazém 1, </p>Pavuna - RJ. CNPJ: 10.285.590/0002-80
       </S.LabelFooter>
    </S.ContainerFooter>
)

export default FooterAddress 